export class DayEnergyCost {
    constructor({
          id= null,         
          day= ``,
          locName= ``, 
          energyName= ``,
          energyCode= ``,         
          energyCost= ``,
          unit= ``,
          
      } = {}) {
      this.id = id;     
      this.day = day;
      this.locName = locName;     
      this.energyName = energyName;
      this.energyCode = energyCode;
      this.energyCost = energyCost;
      this.unit = unit;     
    }
  }
  export function gridFields() {
    return Object.freeze([         
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          } 
        }, 
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },                              
        {
          key: 'energyName',
          label: 'lbl.basic.energyName',
          sortable: false,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'energyCode',
          label: 'lbl.basic.energyCode',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'energyCost',
          label: 'lbl.prd.execution.energyCost',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'unit',
          label: 'lbl.basic.unit',
          sortable: false,
          form: {
            type: 'input'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new DayEnergyCost()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.plantFilter',
    'filter.startDayFilter',
    'filter.endDayFilter', 
    'filter.energyFilter',     
  ];
  export const filter = {
    'plantFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
    'energyFilter': "",
  };